'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$87() {
  this.boI = null;
  this.boJ = false;
}
export { $c_Lpresto_PrestoRouter$$anon$87 as $c_Lpresto_PrestoRouter$$anon$87 };
$p = $c_Lpresto_PrestoRouter$$anon$87.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$87;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$87() {
}
export { $h_Lpresto_PrestoRouter$$anon$87 as $h_Lpresto_PrestoRouter$$anon$87 };
$h_Lpresto_PrestoRouter$$anon$87.prototype = $p;
$p.bW = (function() {
  if ((!this.boJ)) {
    this.boI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.boJ = true;
  }
  return this.boI;
});
$p.P = (function() {
  return this.bW();
});
var $d_Lpresto_PrestoRouter$$anon$87 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$87, "presto.PrestoRouter$$anon$87", ({
  OW: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$87 as $d_Lpresto_PrestoRouter$$anon$87 };
//# sourceMappingURL=presto.-Presto-Router$$anon$87.js.map
